export class UserPrimaryRoleConstants {
  public static OPV: string = 'OPV';
  public static ORS: string = 'ORS';
  public static OCC: string = 'OCC';
}

export class ExternalRolesConstants {
  public static RAO: string = 'RAO';
  public static IR: string = 'IR';
}

export class RolesLegalcertNovaConstants {
  public static ADMIN: string = 'ADMIN';
}
